import { Col, Container, Row } from 'react-bootstrap';

const Hero = () => {
    return (
        <section className="hero-4 pb-5 pt-8 pt-lg-6 pb-lg-8">
            {/* <Container> */}
            <Row className="justify-content-center">
                <Col lg={7} className="text-center position-relative">
                    <h1 className="hero-title text-white">
                        Sales & CRM Blog – Insights, Lead Management & Tracking Strategies
                    </h1>

                    <p className="mt-4 fs-17 text-white">
                        Discover how <strong>Sales Trackify</strong> empowers businesses to streamline sales tracking and optimize performance.
                        Get insights on leveraging cutting-edge tools to track sales activities, improve productivity, and drive revenue growth effectively.
                        Stay updated with expert tips, case studies, and industry trends directly from our blog.
                    </p>
                </Col>
            </Row>
            {/* </Container> */}
        </section>
    );
};

export default Hero;
